// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscriptionsTrigger_IKsC3{margin-left:5px;color:#272525;font-weight:700;text-decoration:underline}.list_lMXTu{display:flex;flex-direction:column;align-items:flex-start;padding:24px;grid-gap:8px;gap:8px}.item_1rX9\\+{background:#fff}.footer_-ZTN-{font-style:italic;font-weight:400;font-size:11px;line-height:15px}.footer_-ZTN- a{color:#252525}.header_GvH1A{font-weight:700;font-size:16px;line-height:22px}.body_yslwv,.header_GvH1A{font-style:normal}.body_yslwv{font-weight:400;font-size:14px;line-height:18px}", ""]);
// Exports
exports.locals = {
	"subscriptionsTrigger": "subscriptionsTrigger_IKsC3",
	"list": "list_lMXTu",
	"item": "item_1rX9+",
	"footer": "footer_-ZTN-",
	"header": "header_GvH1A",
	"body": "body_yslwv"
};
module.exports = exports;
